import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-bancontact-terminal-reminder',
  templateUrl: './bancontact-terminal-reminder.component.html',
  styleUrls: ['./bancontact-terminal-reminder.component.scss'],
})
export class BancontactTerminalReminderComponent {

  constructor(
    private modalController: ModalController,
  ) { }

  async close(): Promise<void> {
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await this.modalController.dismiss();
    }
  }
}
